import React, { useRef, useState } from 'react';
import { Box, CardContent, Grid } from '@mui/material';
import GroupButton from 'components/Buttons/ButtonGroup';
import ContainerCard from 'components/Containers/Card/ContainerCard';
import HeaderCard from 'components/Containers/Card/HeaderCard';
import Identification from './components/Identification';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import { generateNumber } from 'utils';
import Apportionment from 'components/Apportionment';
import Bill from 'components/Bill';

function PayBill() {
  const {
    classes,
    history,
    error,
    success,
    loadingRequest,
    requestCompleted,
    id,
    disable,
    location,
    api,
  } = useDependencyInjection();

  const dataLocation = location.state?.data || location.state?.customData;

  const identificationComponentRef = useRef(null);
  const apportionmentComponentRef = useRef(null);
  const billComponentRef = useRef(null);

  const identificationRef = useRef(null);
  const apportionmentRef = useRef(null);
  const billRef = useRef(null);

  const [billValue, setBillValue] = useState();

  const getBillValue = (value) => {
    setBillValue(value);
  };

  const callbackFunctionIdentification = (payload) => {
    identificationRef.current = payload;
  };

  const callbackFunctionApportionment = (payload) => {
    apportionmentRef.current = payload;
  };

  const callbackFunctionBill = (payload) => {
    billRef.current = payload;
  };

  const formsValid = () => identificationRef.current.isValid && apportionmentRef.current.isValid && billRef.current.isValid;

  const getValues = (ref) => ref.current?.values;

  async function request(data) {
    try {
      loadingRequest();
      if (id) {
        await api.put(`/bills/${id}`, { ...data });
      } else {
        await api.post('/bills', { ...data });
      }
      success();
      history.push('/pay-bills');
    } catch (err) {
      error();
    } finally {
      requestCompleted();
    }
  }

  // dispara submits dos componentes filhos
  const handleSubmitForms = () => {
    apportionmentComponentRef.current.handleSubmit();
    identificationComponentRef.current.handleSubmit();
    billComponentRef.current.handleSubmit();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSubmitForms();

    if (formsValid()) {
      const data = {
        ...getValues(apportionmentRef),
        ...getValues(identificationRef),
        ...getValues(billRef),
        number: generateNumber(getValues(billRef).stakeholder.id),
      };
      request(data);
    }
  };

  return (
    <ContainerCard>
      <form onSubmit={handleSubmit}>
        <Box className={classes.root}>
          <HeaderCard
            title={id ? 'Despesa' : 'Nova Despesa'}
            tooltipText="Essa tela possibilita cadastrar informações relacionadas a uma empresa ou a um vendedor. Dessa forma facilitando o controle de onde e a quem você compra."
          />
          <CardContent sx={{
            '&.MuiCardContent-root': {
              padding: 0,
            },
          }}
          >
            <Grid container direction="column" gap={3}>
              <Grid item>
                <Identification
                  ref={identificationComponentRef}
                  callback={callbackFunctionIdentification}
                />
              </Grid>
              <Grid item>
                <Bill
                  getBillValue={getBillValue}
                  ref={billComponentRef}
                  callback={callbackFunctionBill}
                  type="pagamento"
                  description={dataLocation?.description || getValues(identificationRef)?.description}
                />
              </Grid>
              <Grid item>
                <Apportionment
                  ref={apportionmentComponentRef}
                  billValue={billValue}
                  callback={callbackFunctionApportionment}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Box>
        <GroupButton
          deleteRoute="/bills/"
          routeDelete="/pay-bills"
          returnRoute="/pay-bills"
          id={id}
          disable={disable}
          messageDialogError
          disableTemporary={false} // Desativar o botão de delete
          message="Deletar esse fornecedor pode prejudicar informações ligadas a ele. Tem certeza que deseja excluir?"
        />
      </form>
    </ContainerCard>
  );
}

export default PayBill;
